'use client'

import useTheme from '@/utils/hooks/useTheme'
import HeroBlock from '../HeroBlock'
import NavigationBar from '../NavigationBar'
import { MODE_DARK, MODE_LIGHT } from '@/constants/theme.constant'

type CatalogHeaderProps = {
    pathConfig?: any
}
export const CatalogHeader = ({pathConfig}: CatalogHeaderProps) => {
    const mode = useTheme((state) => state.mode)
    const setMode = useTheme((state) => state.setMode)

    const toggleMode = () => {
        setMode(mode === MODE_LIGHT ? MODE_DARK : MODE_LIGHT)
    }

    return (
        <>
            <NavigationBar pathConfig={pathConfig} />

            <div className="relative">
                <div
                    style={{
                        backgroundImage: `url("/image/others/banner-4.webp"),url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='50' height='50' fill='none' stroke='${mode === MODE_LIGHT ? 'rgb(0 0 0 / 0.04)' : 'rgb(255 255 255 / 0.04)'}'%3e%3cpath d='M0 .5H31.5V32'/%3e%3c/svg%3e")`,
                        backgroundSize: 'cover, 50px 50px',
                        backgroundRepeat: 'no-repeat, repeat',
                        backgroundPosition: 'center, top left',
                    }}
                    className="absolute inset-0 hero-animated-bg [mask-image:linear-gradient(to_bottom,white_5%,transparent_60%)] pointer-events-none select-none"
                ></div>

                <div className="absolute inset-0 z-10 bg-black/30 pointer-events-none select-none [mask-image:linear-gradient(to_bottom,white_5%,transparent_70%)]" />
                <HeroBlock />
            </div>
        </>
    )
}
